const operationsMap = new Map([
  ['up', 'Instalación'],
  ['down', 'Desinstalación']
])

export {operationsMap}



// WEBPACK FOOTER //
// ./src/utils/operations.js